import SBCToggle from "@/components/organisms/SBCs/SBCToggle/SBCToggle";
import { useState } from "react";

export type SetToggleType = "favorite" | "hidden" | "completed";

type Props = {
  isFavorite: boolean;
  isHidden: boolean;
  isCompleted: boolean;
  onClick?: (toggleType: SetToggleType) => void;
  togglesToShow?: SetToggleType[];
};

export const SetToggles = ({
  isCompleted,
  isFavorite,
  isHidden,
  onClick,
  togglesToShow = ["favorite", "hidden", "completed"],
}: Props) => {
  const [hovered, setHovered] = useState<SetToggleType | "">("");

  const renderToggle = (type: SetToggleType) => {
    const isActive =
      type === "favorite"
        ? isFavorite
        : type === "hidden"
          ? isHidden
          : isCompleted;

    console.log("hits the toggle");

    return (
      <SBCToggle
        key={type}
        type={type === "hidden" ? "hide" : type}
        onClick={() => {
          if (onClick) onClick(type);
        }}
        onMouseEnter={() => setHovered(type)}
        onMouseLeave={() => setHovered("")}
        state={hovered === type ? "hovered" : isActive ? "active" : ""}
      />
    );
  };

  return (
    <div className="flex gap-x-2">
      {togglesToShow.map((type) => renderToggle(type))}
    </div>
  );
};
